import iframe from '@ps/bridge/iframe/iframe'
import qc from 'qc'
import _ from 'lodash'

function updateUuid2UrlConf(conf: qc.Uuid2Url) {
  const uuid2Url = iframe.assets._uuid2UrlConf
  // 由于旧代码中 game.uuid2conf 是直接修改 _uuid2UrlConf 的引用，所以为了兼容这里也这么处理
  _.each(conf, (item, key) => {
    uuid2Url[key] = conf[key]
  })
}

function getUuidByUrl(path: string) {
  const uuid2Url = iframe.assets._uuid2UrlConf
  return _.findKey(uuid2Url, (item) => item === path)
}

export default {
  /**
   * 请求加载图片资源，加载成功后调用回调通知
   *
   * @param uuid {string|undefined} - 需要保证资源ID的唯一。不指定时使用url作为key
   * @param url {string} - 资源的地址（可选参数）
   * @param override - 是否无视是否已缓存强制加载（成功加载后覆盖资源）
   */
  async load({
    uuid,
    url,
    override,
    isRaw,
  }: {
    uuid?: string
    url: string
    override?: boolean
    isRaw?: boolean
  }) {
    return new Promise((resolve, reject) => {
      if (uuid) {
        iframe.assets.load(
          uuid,
          url,
          (asset: any) => {
            resolve(asset)
          },
          override,
          isRaw,
        )
      } else {
        iframe.assets.load(
          '',
          url,
          // @ts-ignore
          (asset: any) => {
            resolve(asset)
          },
          override,
        )
      }
    })
  },

  get uuid2UrlConf(): qc.Uuid2Url {
    return iframe.assets._uuid2UrlConf
  },

  set uuid2UrlConf(conf: qc.Uuid2Url) {
    updateUuid2UrlConf(conf)
  },

  updateUuid2UrlConf,

  getUuidByUrl,

  get findByUUID() {
    return iframe.assets.findByUUID
  },
}
